import { Button } from '@material-ui/core'
import _ from 'lodash'
import React, { useEffect } from 'react'

import { uploadFile } from '../../services/file-services'
import { buttonsStyles } from '../../styles/ButtonsStyles'
import { fileStyles } from '../../styles/FileStyles'
import { invoke } from '../../utils/helper'
import { FileType } from '../../utils/types'
import { CropperModal } from './CropperModal'

type Props = {
    uri?: string
    imgHeight: number
    imgWidth: number
    onChange(file: FileType | undefined): void
}

export const ImageEditor: React.FC<Props> = ({
    uri,
    onChange,
    imgHeight, imgWidth
}) => {
    const [inputId] = React.useState(_.uniqueId('upload-'))
    const [file, setFile] = React.useState<File>()
    const [finalImageUrl, setFinalImageUrl] = React.useState<string | undefined>(uri)
    const styles = buttonsStyles()
    const fStyles = fileStyles()

    useEffect(() => {
        setFinalImageUrl(uri)
    }, [uri])

    const load = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (e.target?.files?.length) {
            setFile(e.target.files[0])
        }
    }

    const clear = () => {
        onChange(undefined)
        setFinalImageUrl(undefined)
    }

    const finalize = async (f: File | undefined) => {
        setFile(undefined)

        if (!f) {
            return
        }

        const r = await invoke(async () => {
            return uploadFile(f)
        }, {
            operation: 'Uploader Billede'
        })

        setFinalImageUrl(r.uri)
        onChange({
            name: f.name,
            key: r.key,
            uri: r.uri
        })
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <input
                accept="image/jpeg,image/png"
                style={{ display: 'none' }}
                id={inputId}
                type="file"
                onChange={load}/>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor={inputId}>
                    <Button
                        className={fStyles.btnUpload}
                        component="span">
                        Upload
                    </Button>
                </label>
                {finalImageUrl && (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Button
                            className={styles.unselectFile}
                            type="button"
                            onClick={clear}> X
                        </Button>
                    </div>
                )}
            </div>
            <small style={{ color: 'white' }}>Formatet png, jpeg, jpg. Max 5MB</small>
            <CropperModal
                cropHeight={imgHeight}
                cropWidth={imgWidth}
                file={file}
                onEdit={finalize}/>
        </div>
    )
}

ImageEditor.defaultProps = {
    uri: undefined
}
